/* eslint-disable jsx-a11y/label-has-for */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './AppSwitch.sass';

class AppSwitch extends Component {
  constructor(props) {
    super(props);
    this.state = { checked: props.defaultChecked };
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
  }

  componentDidMount() {
    if (this.props.defaultChecked) {
      this.checkbox.checked = true;
    }
  }

  handleCheckboxChange({ target: { checked } }) {
    const { onChange, title } = this.props;
    this.setState({ checked }, () => { onChange({ title, checked }); });
  }

  checked() {
    return this.state.checked;
  }

  render() {
    const { className, title, position } = this.props;
    const { checked } = this.state;

    return (
      <div className={`AppSwitch ${className}`}>
        <label className={checked ? 'checked' : ''}>
          <input
            ref={(c) => { this.checkbox = c; }}
            type="checkbox"
            className="checkbox-input"
            onChange={this.handleCheckboxChange}
          />
          {position === 'right' ? <span className="checkbox-title">{title}</span> : undefined}
          <span className="outer-frame"><span className="inner-switch" /></span>
          {position === 'left' ? <span className="checkbox-title">{title}</span> : undefined}
        </label>
      </div>
    );
  }
}

AppSwitch.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  position: PropTypes.string,
  onChange: PropTypes.func,
  defaultChecked: PropTypes.bool
};

AppSwitch.defaultProps = {
  className: '',
  position: 'left',
  onChange() {},
  defaultChecked: false
};

export default AppSwitch;



// WEBPACK FOOTER //
// ./src/components/AppSwitch.jsx